var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_775)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50,
    height: 50,
    rx: 12,
    fill: "#C3F1FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_516_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48882 41.3994C8.86557 44.7901 11.3952 47.4812 11.6643 51.0872C11.6643 51.141 11.6643 51.141 11.6643 51.1949H16.7773C16.9926 47.6965 14.9474 45.436 14.6783 41.7761C14.4092 38.0625 17.5308 35.6405 16.8311 31.6577C16.0776 27.7288 13.7633 25.3606 16.4006 21.647C17.6923 19.7632 18.8763 16.7492 18.6072 14.4349C18.3919 12.3359 17.2079 11.69 15.8085 11.8515C14.3553 12.013 12.7407 12.9817 11.6643 14.1658C10.2111 15.7266 9.4576 17.6642 9.29614 19.817C8.97321 23.4231 11.2875 26.4909 11.0184 30.4198C10.7493 34.1873 8.00443 37.4166 8.48882 41.3994Z",
    fill: "#472B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1275 51.1951C41.8583 48.3964 40.9972 44.0907 38.36 44.0369C38.36 44.0369 32.7625 42.3146 33.1393 51.1951H42.1275Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2092 33.165H22.9121V41.615H29.2092V33.165Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8262 45.2748C13.6023 42.5838 16.3472 41.8303 16.3472 41.8303L22.9134 39.3545H29.2105L35.8305 41.8303C35.8305 41.8303 38.5754 42.5838 40.3515 45.2748H11.8262Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9834 29.9361C20.1674 31.766 21.7282 33.273 23.8273 34.2418C24.5808 34.6185 25.4419 34.9415 26.2492 35.1029C26.8413 35.2644 28.1868 35.695 28.7788 35.4258C37.2826 31.7122 34.4839 15.4043 34.4839 15.4043C33.246 7.65405 26.5183 7.65405 26.5183 7.65405C21.4591 7.43877 16.8843 9.80691 16.077 15.1352C15.7541 17.1804 16.1846 19.3333 16.2923 21.3785C16.3461 22.8855 16.5614 24.3925 17.0458 25.7918C17.5302 27.2988 18.176 28.6982 18.9834 29.9361Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7037 34.8333C23.9362 34.5642 20.9222 31.6579 18.3926 28.9668C18.554 29.2897 18.7693 29.6665 18.9846 29.9894C20.1687 31.8193 21.7295 33.3263 23.8285 34.2951C24.582 34.6719 25.4432 34.9948 26.2505 35.1562C26.8425 35.3177 28.1881 35.7483 28.7801 35.4792C30.1256 34.8871 31.1482 34.026 32.0094 32.8958C30.8253 33.7031 29.1568 34.941 27.7037 34.8333Z",
    fill: "#E6AB86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7376 30.9577C18.9841 25.2526 18.8226 20.8931 23.1822 18.9556C26.1423 17.6638 27.4879 16.9642 27.3264 13.1428C27.1649 9.10625 27.5955 7.27633 24.4739 6.46901C19.7376 5.23112 14.9475 9.21389 13.8173 14.1655C13.8173 14.1655 10.5342 25.5756 19.7376 30.9577Z",
    fill: "#472B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7375 24.0151C19.7375 24.0151 19.0916 21.2164 16.9388 22.4005C16.9388 22.4005 15.97 22.8849 16.6697 24.8224C16.6697 24.8224 17.6923 27.5673 19.7375 26.5447V24.0151Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1982 51.1951C35.238 44.4674 34.646 41.3996 34.646 41.3996L31.3629 40.1617C30.8785 42.3146 28.5641 43.2295 28.5641 43.2295C24.2046 42.7451 21.2983 40.0002 21.2983 40.0002L16.4005 41.8302C16.4005 41.8302 11.449 43.1757 10.5878 48.7731L12.1486 51.1413H38.1982V51.1951Z",
    fill: "#00487A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4465 51.1949C18.4465 42.7449 13.4949 44.0366 13.4949 44.0366C10.8577 44.0905 10.0504 48.3962 9.78125 51.1949H18.4465Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8785 15.35C32.0625 15.7267 33.0313 16.2649 34.0001 17.3414C34.8074 18.2563 34.8613 18.8484 34.9689 21.5932C35.0227 22.7773 38.7364 19.6557 38.0905 13.4662C37.8214 11.2057 36.4221 9.1067 34.5383 7.86881C33.139 7.00767 28.7794 4.0475 21.9441 6.52328C19.4145 7.38442 25.4425 13.6815 30.8785 15.35Z",
    fill: "#472B0E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_775"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50,
    height: 50,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_516_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.564,
    height: 50,
    fill: "white",
    transform: "translate(3 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.8a14cb13d12862c984ee4bee34a613d5.svg";
export { ForwardRef as ReactComponent };